import React, { useEffect, useState } from 'react'
import Navigation from '../NavigationBar'
import TopBar from '../TopBar'
import { ToggleNavContext } from '../../helpers/context'
import MainContainer from '../MainContainer';
import { useNavigate } from 'react-router-dom';

export default function DashNav(props) {
    const navigate = useNavigate();
    const token = localStorage.getItem('token')

    const [isToggled, setToggle] = useState(false);

    useEffect(() => {
        if (!token) {
            navigate('/')
        }
    }, [token])

    return (
        <ToggleNavContext.Provider value={{ isToggled, setToggle }}>
            <Navigation />
            <TopBar />
            <MainContainer component={props.component} />
        </ToggleNavContext.Provider>
    )
}
